
import { connect } from 'react-redux';
import { formatCurrency } from '../../../shared/utility';
import Item from '../../../components/Item/Item';
import CircularProgress from '@mui/material/CircularProgress';

import styled from 'styled-components';

const OrderWrapper = styled.form`
    max-width: 400px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
    margin: 20px auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
`
const OrderHeading = styled.h1`
    font-size: 26px;
    line-height: 1.4;
    margin: 0 0 20px;
    text-align: center;
    text-transform: capitalize;
`
const SummaryList = styled.ul`
    font-size: 26px;
    line-height: 1.4;
    margin: 0 0 20px;
    text-align: center;
    text-transform: capitalize;
    padding:15px;
    list-style: none;
    background: #F5F7FA
`
const SummaryListItem = styled.li`
    font-size: 14px;
    line-height: 20px;
    color: #666E7F;
    text-align: center;
    text-transform: capitalize;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:10px;
    &:last-child {
        margin-bottom: 0;
    }
`
const SummaryListValue = styled.span`
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: #2F3842;
    text-align: center;
    text-transform: capitalize;
`
const SummaryMessage = styled.span`
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: #DF1338;
    text-align: center;
    text-transform: capitalize;
`
const OrderTotal = styled.p`
    margin:0 0 20px;
    padding: 0 15px;
    font-size: 18px;
    line-height: 25px;
    font-weight: 500;
    color: #2F3842;
    text-transform: capitalize;
    display: flex;
    align-items: center;
    justify-content: space-between;
`
const TotalPrice = styled.span`
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    color: #2F3842;
    text-transform: capitalize;
`

const Button = styled.button`
    font-size:17px;
    padding:15px 30px;
    display: flex;
    align-items:center;
    justify-content: center;
    height: 50px;
    width:100%;
    background: linear-gradient(90deg, #034694 0%, #0170C1 100%);
    color: #fff;
    border:0;
    outline: none;
    cursor: pointer;
    text-transform: capitalize;
    transition: 0.3s ease-in-out;
    box-shadow: 0px 8px 12px rgba(3, 72, 150, 0.15);
    &:disabled {
        background: #eee;
        color: #999;
        box-shadow: none;
    }
`

const OrderSummary = props => {
    const { cartItems , subTotal, shipping , payment , valid, onConfirm } = props;

    console.log(subTotal, shipping , payment);
    
    let fetchedCartItems = <CircularProgress />;

    if ( cartItems.length ) {
        fetchedCartItems = cartItems.map( item => {
            return <Item key={item.id} id={item.orderId} img={ '#'+ item.imageColor} name={item.name} 
            price= {formatCurrency( ( item.priceCents / 100 ) * item.quantity )} quantity={item.quantity} />
        })
    }

    return (
        <OrderWrapper>
            <OrderHeading>order summary</OrderHeading>
            {fetchedCartItems}
            <SummaryList>
                    <SummaryListItem>subtotal:
                        <SummaryListValue>
                            {formatCurrency(subTotal)}
                        </SummaryListValue>
                    </SummaryListItem>
                    <SummaryListItem>shipping price:
                        <SummaryListValue>
                            {formatCurrency(shipping)}
                        </SummaryListValue>
                    </SummaryListItem>
                    <SummaryListItem>payment method:
                        <SummaryListValue>
                            {payment}
                        </SummaryListValue>
                    </SummaryListItem>
                    { shipping === 0 &&
                        <SummaryListItem>
                            <SummaryMessage>
                                shipping is free because your order is more than $100.00
                            </SummaryMessage>
                        </SummaryListItem>
                    }
            </SummaryList>
            <OrderTotal>Total to pay:<TotalPrice>{ formatCurrency( (subTotal + shipping) ) }</TotalPrice></OrderTotal>
            <Button type="submit" disabled={!valid} onClick={ event => onConfirm(event) }>Confirm & Pay</Button>
        </OrderWrapper>
    )
}


const mapStateToProps = state =>{
    return {
        cartItems: state.cart.cartItems,
    }
}


export default connect( mapStateToProps , null )(OrderSummary);